import { ref } from 'vue';

const fetchData = async (url) => {
  const fetchResult = ref(null);
  const fetchError = ref(null);

  try {
    const res = await fetch(url);
    const data = await res.json();
    if (data.status > 300) {
      throw new Error('Something went Wrong');
    }
    fetchResult.value = data;
  } catch (err) {
    fetchError.value = err.message;
  }

  return {
    fetchResult,
    fetchError,
  };
};

export default function useFetch() {
  return fetchData;
}
